import axios from "axios";
import { createEffect, createEvent, createStore } from "effector";
import { getCustomUserAgent } from "../../../customUserAgent";
import { getUuidAndSession } from "../../../localStorage";

export interface INotification{
    accountId:string
    activity:string
    body:string
    companyId:string
    data:string
    dt:string
    eventId:string
    houseId:string
    id:string
    recipient:string
    result:string
    title:string
    tokens:string
    userId:string
}

export const $Notifications = createStore<INotification[]>({} as INotification[])

export const getNotifications = createEffect<number, INotification[]>();

export const $currentNotification = createStore<number>(-1)
export const setCurrentNotification = createEvent<number>();
export const clearNotification = createEvent()
$currentNotification.reset(clearNotification)
$currentNotification.on(setCurrentNotification, (_,val)=>val);

$Notifications.on(getNotifications.doneData, (_, val) => val);

getNotifications.use((accountId) =>
  axios.post("https://izba.kras-abs.ru/api/v3/notifications/getNotificationsAbs", {
    ...getUuidAndSession(),
    accountId: accountId,
    },{
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Custom-User-Agent": getCustomUserAgent(),
      }
    }).then((resp) => {
      return resp.data.notifications
    })
);